// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, or any plugin's
// vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file. JavaScript code in this file should be added after the last require_* statement.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.
//
//= require jquery
//= require jquery_ujs
//= require jquery-ui/core
//= require jquery-ui/widget
//= require jquery-ui/widgets/mouse
//= require jquery-ui/widgets/button
//= require jquery-ui/widgets/autocomplete
//= require jquery-ui/effects/effect-slide
//= require jquery.scrollintoview
//= require jquery.flexslider
//= require fastclick
//= require foundation
//= require foundation.joyride.min
//= require rails.validations
//= require rails.validations.simple_form
//= require tooltipster.bundle.min
//= require clipboard
//= require GeoJSON
//= require wordcloud2
//= require retina_tag
//= require_tree .
//= require jquery
//= require jquery_ujs

var csv = ClientSideValidations.formBuilders['SimpleForm::FormBuilder'].wrappers;
csv["foundation"] = csv["default"];

window.ClientSideValidations.callbacks.form.fail = function(form, eventData) {
  analytics.track('Validation Error');
};

$(function(){
  $("[data-open]").click(function(e) { e.preventDefault(); });
  window.when$ready && window.when$ready();
});

//$(function(){ $(document).foundation(); });

//$(document).on('turbolinks:load', function() {
//    $(function(){ $(document).foundation(); });
//});
